/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-helpers';
import MemberFilterPanel from '@common/MemberFilterPanel';

const AccountMemberFilterPanel = ({
  accessLevelSearchInput,
  accessLevels,
  companies,
  companySearchInput,
  isFetchingCompanies,
  isFetchingRoles,
  onAccessLevelChange,
  onChangeAccessLevelInput,
  onChangeCompanyInput,
  onChangeRoleInput,
  onChangeStatusInput,
  onClose,
  onCompanyChange,
  onRoleChange,
  onStatusChange,
  open,
  roleSearchInput,
  roles,
  selectedAccessLevel,
  selectedCompany,
  selectedRole,
  selectedStatus,
  status,
  statusSearchInput,
}) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  return (
    <MemberFilterPanel
      accessLevelSearchInput={accessLevelSearchInput}
      accessLevels={accessLevels}
      companies={companies}
      companySearchInput={companySearchInput}
      isFetchingCompanies={isFetchingCompanies}
      isFetchingRoles={isFetchingRoles}
      onAccessLevelChange={onAccessLevelChange}
      onChangeAccessLevelInput={onChangeAccessLevelInput}
      onChangeCompanyInput={onChangeCompanyInput}
      onChangeRoleInput={onChangeRoleInput}
      onChangeStatusInput={onChangeStatusInput}
      onClose={onClose}
      onCompanyChange={onCompanyChange}
      onRoleChange={onRoleChange}
      onStatusChange={onStatusChange}
      open={open}
      roleSearchInput={roleSearchInput}
      roles={roles}
      selectedAccessLevel={selectedAccessLevel}
      selectedCompany={selectedCompany}
      selectedRole={selectedRole}
      selectedStatus={selectedStatus}
      status={status}
      statusSearchInput={statusSearchInput}
      title={T.translate('ACCOUNT_MEMBER_FILTER_PANEL_TITLE')}
    />
  );
};

AccountMemberFilterPanel.propTypes = {
  accessLevelSearchInput: PropTypes.string,
  accessLevels: PropTypes.array,
  companies: PropTypes.array,
  companySearchInput: PropTypes.string,
  isFetchingCompanies: PropTypes.bool,
  isFetchingRoles: PropTypes.bool,
  onAccessLevelChange: PropTypes.func,
  onChangeAccessLevelInput: PropTypes.func,
  onChangeCompanyInput: PropTypes.func,
  onChangeRoleInput: PropTypes.func,
  onChangeStatusInput: PropTypes.func,
  onClose: PropTypes.func,
  onCompanyChange: PropTypes.func,
  onRoleChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  open: PropTypes.bool,
  roleSearchInput: PropTypes.string,
  roles: PropTypes.array,
  selectedAccessLevel: PropTypes.object,
  selectedCompany: PropTypes.object,
  selectedRole: PropTypes.object,
  selectedStatus: PropTypes.object,
  status: PropTypes.array,
  statusSearchInput: PropTypes.string,
};

AccountMemberFilterPanel.defaultProps = {
  accessLevelSearchInput: '',
  accessLevels: [],
  companies: [],
  companySearchInput: '',
  isFetchingCompanies: false,
  isFetchingRoles: false,
  onAccessLevelChange: () => {},
  onChangeAccessLevelInput: () => {},
  onChangeCompanyInput: () => {},
  onChangeRoleInput: () => {},
  onChangeStatusInput: () => {},
  onClose: () => {},
  onCompanyChange: () => {},
  onRoleChange: () => {},
  onStatusChange: () => {},
  open: false,
  roleSearchInput: '',
  roles: [],
  status: [],
  statusSearchInput: '',
};

export default AccountMemberFilterPanel;
